var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaypal(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 51.289,
    height: 13.824,
    viewBox: "0 0 51.289 13.824",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Paypal",
    transform: "translate(0 -0.837)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_106",
    "data-name": "Path 106",
    d: "M6.162.837H2.168a.556.556,0,0,0-.548.47L0,11.59a.333.333,0,0,0,.329.386H2.24a.556.556,0,0,0,.548-.471l.436-2.774a.555.555,0,0,1,.548-.471H5.037c2.631,0,4.149-1.278,4.546-3.811a3.1,3.1,0,0,0-.509-2.589A3.7,3.7,0,0,0,6.162.837Zm.461,3.756C6.4,6.032,5.309,6.032,4.251,6.032h-.6l.423-2.687A.333.333,0,0,1,4.4,3.062h.276c.721,0,1.4,0,1.753.413a1.341,1.341,0,0,1,.194,1.118Z",
    transform: "translate(0 0)",
    fill: "#28356a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107",
    "data-name": "Path 107",
    d: "M17.125,4.063H15.213a.334.334,0,0,0-.329.282l-.085.537-.134-.195a2.716,2.716,0,0,0-2.259-.805,4.4,4.4,0,0,0-4.27,3.862,3.635,3.635,0,0,0,.713,2.95,2.987,2.987,0,0,0,2.409.977,3.653,3.653,0,0,0,2.647-1.1l-.085.534a.334.334,0,0,0,.328.387h1.723a.556.556,0,0,0,.549-.471l1.034-6.573A.332.332,0,0,0,17.125,4.063ZM14.459,7.8A2.134,2.134,0,0,1,12.3,9.634a1.611,1.611,0,0,1-1.284-.518,1.638,1.638,0,0,1-.3-1.349,2.144,2.144,0,0,1,2.143-1.848,1.611,1.611,0,0,1,1.275.523A1.667,1.667,0,0,1,14.459,7.8Z",
    transform: "translate(1.077 0.406)",
    fill: "#28356a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108",
    "data-name": "Path 108",
    d: "M25.968,4.187H24.045a.556.556,0,0,0-.459.245l-2.651,3.92L19.811,4.584a.557.557,0,0,0-.533-.4H17.39a.334.334,0,0,0-.316.442l2.117,6.238L17.2,13.688a.334.334,0,0,0,.272.528h1.92a.553.553,0,0,0,.456-.239l6.392-9.265a.334.334,0,0,0-.273-.525",
    transform: "translate(2.274 0.447)",
    fill: "#28356a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_109",
    "data-name": "Path 109",
    d: "M31.3.837H27.3a.556.556,0,0,0-.548.47L25.14,11.59a.333.333,0,0,0,.328.386h2.05a.389.389,0,0,0,.383-.329l.459-2.915a.555.555,0,0,1,.548-.471h1.264c2.631,0,4.149-1.278,4.546-3.811a3.1,3.1,0,0,0-.51-2.589A3.694,3.694,0,0,0,31.3.837Zm.461,3.756c-.218,1.439-1.313,1.439-2.372,1.439h-.6l.423-2.687a.332.332,0,0,1,.328-.282h.276c.721,0,1.4,0,1.753.413a1.34,1.34,0,0,1,.193,1.118Z",
    transform: "translate(3.351)",
    fill: "#298fc2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110",
    "data-name": "Path 110",
    d: "M42.259,4.063H40.347a.332.332,0,0,0-.328.282l-.085.537L39.8,4.687a2.715,2.715,0,0,0-2.258-.805,4.4,4.4,0,0,0-4.269,3.862,3.638,3.638,0,0,0,.712,2.95,2.989,2.989,0,0,0,2.409.977,3.654,3.654,0,0,0,2.647-1.1l-.085.534a.334.334,0,0,0,.329.387h1.722a.555.555,0,0,0,.548-.471l1.034-6.573A.334.334,0,0,0,42.259,4.063ZM39.593,7.8a2.133,2.133,0,0,1-2.158,1.833,1.612,1.612,0,0,1-1.284-.518,1.643,1.643,0,0,1-.3-1.349,2.145,2.145,0,0,1,2.143-1.848,1.611,1.611,0,0,1,1.275.523A1.66,1.66,0,0,1,39.593,7.8Z",
    transform: "translate(4.429 0.406)",
    fill: "#298fc2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111",
    "data-name": "Path 111",
    d: "M43.237,1.12,41.6,11.591a.333.333,0,0,0,.328.386h1.648a.555.555,0,0,0,.548-.471L45.739,1.223a.334.334,0,0,0-.328-.386H43.565a.334.334,0,0,0-.328.283",
    transform: "translate(5.546)",
    fill: "#298fc2",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaypal);
export default __webpack_public_path__ + "static/media/Paypal.ad34aa86ad457186fa5ca765a7e85162.svg";
export { ForwardRef as ReactComponent };